import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const RefreshIcon = (props: IconProps) => (
  <Icon viewBox="0 0 17 16" title={t`Refresh`} {...props}>
    <Path
      id="Ellipse 217"
      d="M13.6004 7.9999C13.6004 4.90711 11.0932 2.3999 8.00039 2.3999M8.00039 13.5999C4.9076 13.5999 2.40039 11.0927 2.40039 7.9999"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <Path
      id="Vector 210"
      d="M8.00039 0.800049L6.40039 2.40005L8.00039 4.00005"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      id="Vector 211"
      d="M7.99961 12L9.59961 13.6L7.99961 15.2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default RefreshIcon;
